//
// Module for the Report History index view
//
rs.module("reports/history/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(reportHistoryGridLrsApi, backendUrls, variables) {

            // If viewing only the user's report history and any reports are still running,
            // setup a timer to run in 5 seconds to check for updates 
            if (!variables.allUsers && reportHistoryGridLrsApi.agGridApi.pg.gridOptions.context.isRunning) {
                _setupTimer();
            } 

            //
            // Setup timer for delayed Report History grid refresh
            //
            function _setupTimer() {
                setTimeout(refreshReportHistoryGrid, 5000);
            }

            //
            // Refresh the Report History grid
            //
            function refreshReportHistoryGrid() {

                gridModule.update(
                    backendUrls.getReportHistoryGrid,
                    {
                        allUsers: variables.allUsers,
                        executionFromDate: variables.executionFromDate,
                        executionToDate: variables.executionToDate,
                        submittedReportInstanceId: variables.submittedReportInstanceId,
                        submittedReportName: variables.submittedReportName
                    },
                    reportHistoryGridLrsApi.agGridApi,
                    function done(gridUpdate) {

                        // If viewing only the user's report history and any reports are still running, 
                        // setup a new timer to run in 5 seconds to check again for updates 
                        if (!variables.allUsers && gridUpdate.context.isRunning) {
                            _setupTimer();
                        }
                    }
                );
            }            
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);